module.exports = __webpack_public_path__ + "static/media/covi_del_pal_del.a5ec6f5d.png";